<template>
  <div id="home">
    <!-- container -->
    <div class="containers">
      <!-- content-wrap -->
      <div class="content_wrap">
        <div id="slider1" class="carousel slide slider" data-bs-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active" data-bs-interval="5000">
              <img src="../../image/main/01.jpeg" class="d-block w-100" />
            </div>
            <div class="carousel-item" data-bs-interval="5000">
              <img src="../../image/main/02.jpeg" class="d-block w-100" />
            </div>
            <div class="carousel-item" data-bs-interval="5000">
              <img src="../../image/main/03.jpeg" class="d-block w-100" />
            </div>
          </div>
        </div>
        <!-- content -->
        <div class="content">
          <h2>MAGNET SYSTEM<br /><br /></h2>
          <span> ERP / MES / POP / Mobile / Barcode System </span>
          <p>솔루션 전문기업</p>
        </div>
      </div>
      <!-- menuList -->
      <div class="menuList">
        <router-link :to="{ name: 'aboutCorp' }">
          <div class="back"><img src="../../image/main/04.jpeg" /></div>
          <div class="front">
            <h2>회사소개</h2>
            <p>ERP / MES / POP</p>
            <p>고객 맞춤형 솔루션을 구축 고객 만족 <br />서비스를 제공합니다.</p>
          </div>
        </router-link>

        <router-link :to="{ name: 'noticeList' }">
          <div class="back"><img src="../../image/main/05.jpg" /></div>
          <div class="front">
            <h2>고객 상담 문의</h2>
            <p>제품 관련 문의 또는 솔루션 상담</p>
          </div>
        </router-link>

        <a href="../../exe/magnet-0.exe">
          <div class="back"><img src="../../image/main/06.jpg" /></div>
          <div class="front">
            <h2>원격지원</h2>
            <p>문제 발생시 원격으로 지원해 드립니다.</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped src="@/style/index.css">
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
</style>
